import { useContext } from 'react';

import { HistogramLoadingContext } from '../contexts/HistogramLoading.context.js';

export const useHistogramLoading = () => useContext(HistogramLoadingContext);
